export const SITE_JZB = 'jzb'
export const SITE_ZHONGKAO = 'zhongkao'
export const SITE_GAOKAO = 'gaokao'
export const SITE_AOSHU = 'aoshu'
export const SITE_ZUOWEN = 'zuowen'
export const SITE_YOUJIAO = 'youjiao'

export const DEFAULT_SITE = SITE_GAOKAO // 默认站点

export const siteMap = {
  [SITE_ZHONGKAO]: {
    domain: 'zhongkao.com',
    gradeSection: [7, 9],
    defaultGrade: 7,
    defaultSubject: 2,
    hotPaperParams: {
      grade: 9,
      position_id: "1",
      subject: "2",
    },
    urlParams:{
      m:{
        utm_source:'zhongkao',
        from: 'm.zhongkao.com'
      },
      pc:{
        utm_source:'pczhongkao',
        from: 'zhongkao.com'
      }
    },
    name: '中考网',
    index: 'https://www.zhongkao.com',
    tikuKey: 4 // 对应的题库key
  },
  [SITE_GAOKAO]: {
    domain: 'gaokao.com',
    gradeSection: [10, 12],
    defaultGrade: 10,
    defaultSubject: 2,
    hotPaperParams: {
      grade: 12,
      position_id: "1",
      subject: "2",
    },
    urlParams:{
      m:{
        utm_source:'gaokao',
        from: 'm.gaokao.com'
      },
      pc:{
        utm_source:'pcgaokao',
        from: 'gaokao.com'
      }
    },
    name: '高考网',
    index: 'https://www.gaokao.com',
    tikuKey: 6
  },
  [SITE_AOSHU]: {
    domain: 'aoshu.com',
    gradeSection: [1, 6],
    defaultGrade: 1,
    defaultSubject: 2,
    hotPaperParams: {
      grade: 5,
      position_id: "1",
      subject: "2"
    },
    urlParams:{
      m:{
        utm_source:'aoshu',
        from: 'm.aoshu.com'
      },
      pc:{
        utm_source:'pcaoshu',
        from: 'aoshu.com'
      }
    },
    name: '奥数网',
    index: 'https://www.aoshu.com',
    tikuKey: 1
  },
  [SITE_ZUOWEN]: {
    domain: 'zuowen.com',
    gradeSection: [1, 6],
    defaultGrade: 1,
    defaultSubject: 1,
    hotPaperParams: {
      grade: 5,
      position_id: "1",
      subject: "1"
    },
    urlParams:{
      m:{
        utm_source:'zuowen',
        from: 'm.zuowen.com'
      },
      pc:{
        utm_source:'pczuowen',
        from: 'zuowen.com'
      }
    },
    name: '作文网',
    index: 'https://www.zuowen.com',
    tikuKey: 6
  },
  [SITE_YOUJIAO]: {
    domain: 'youjiao.com',
    gradeSection: [1, 6],
    defaultGrade: 1,
    defaultSubject: 2,
    hotPaperParams: {
      grade: 5,
      position_id: "1",
      subject: "1"
    },
    urlParams:{
      m:{
        utm_source:'youjiao',
        from: 'm.youjiao.com'
      },
      pc:{
        utm_source:'pcyoujiao',
        from: 'youjiao.com'
      }
    },
    name: '幼教网',
    index: 'https://www.youjiao.com',
    tikuKey: 1
  },
  [SITE_JZB]: {
    domain: 'jzb.com',
    gradeSection: [1, 6],
    defaultGrade: 1,
    defaultSubject: 2,
    hotPaperParams: {
      grade: 5,
      position_id: "1",
      subject: "1"
    },
    urlParams:{
      m:{
        utm_source:'jzb',
        from: 'm.jzb.com'
      },
      pc:{
        utm_source:'pcjzb',
        from: 'jzb.com'
      }
    },
    name: '家长帮',
    index: 'https://www.jzb.com',
    tikuKey: 6
  }
}

export function getCurrentSite() {
  const currentHost = window.location.hostname
  let currentSite = DEFAULT_SITE
  for (const site in siteMap) {
    if (currentHost.includes(site)) {
      currentSite = site
      return currentSite
    }
  }

  for (const item of [SITE_ZUOWEN, SITE_ZHONGKAO, SITE_GAOKAO, SITE_AOSHU]) {
    if (window.location.href.indexOf(item) >= 0) {
      return item
    }
  }

  return currentSite
}

export function getCurrentSiteInfo() {
  return siteMap[getCurrentSite()]
}

let globalInit = false

export default {
  computed: {
    currentSite() {
      return getCurrentSite()
    },
    currentSiteInfo() {
      return siteMap[this.currentSite]
    },
    currentSiteLogo() {
      return this.currentSiteInfo.logo
    },
    currentSiteLogoWidth() {
      return this.currentSiteInfo.logoWidth
    },
    isSiteJzb() {
      return this.currentSite === SITE_JZB
    },
    isMobile(){
      return window.location.href.indexOf(`m.${this.currentSiteInfo.domain}`)>=0
    },
    urlParams(){
       return this.isMobile ? this.currentSiteInfo.urlParams.m : this.currentSiteInfo.urlParams.pc
    }
  },
  created() {
    if (!globalInit) {
      globalInit = true
      const site = getCurrentSite()
      const siteClass = `site-${site}`
      let className = document.body.className || ''
      if (className) {
        className += ' '
      }
      className += siteClass
      document.body.className = className
    }
  }
}
